import * as pdfjsLib from "pdfjs-dist";
import mammoth from "mammoth";
import type { VaultFile } from "@/types/vault";

// Initialize PDF.js worker
if (typeof window !== "undefined") {
  pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
}

export async function extractTextFromFile(file: File): Promise<string> {
  const mimeType = file.type || getMimeTypeFromFilename(file.name);

  if (mimeType === "application/pdf") {
    return await extractTextFromPDF(file);
  } else if (
    mimeType ===
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return await extractTextFromDOCX(file);
  } else if (
    mimeType === "text/plain" ||
    mimeType === "text/markdown" ||
    file.name.endsWith(".txt") ||
    file.name.endsWith(".md")
  ) {
    return await extractTextFromPlain(file);
  }

  throw new Error(`Unsupported file type: ${mimeType}`);
}

async function extractTextFromPDF(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const pages: string[] = [];

  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const textContent = await page.getTextContent();
    const pageText = textContent.items
      .map((item: any) => item.str)
      .join(" ");
    pages.push(pageText);
  }

  return pages.join("\n\n");
}

async function extractTextFromDOCX(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer });
  return result.value;
}

async function extractTextFromPlain(file: File): Promise<string> {
  return await file.text();
}

function getMimeTypeFromFilename(filename: string): string {
  const ext = filename.toLowerCase().split(".").pop();
  const mimeTypes: Record<string, string> = {
    pdf: "application/pdf",
    docx:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    txt: "text/plain",
    md: "text/markdown",
  };
  return mimeTypes[ext || ""] || "application/octet-stream";
}

